// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ik-j";
export var fulfillmentFormRail = "_ik-i";
export var headerTitleRow = "_ik-l";
export var orderDetailsWrapper = "_ik-g";
export var orderLinkTrigger = "_ik-2";
export var paymentInformationGrid = "_ik-q";
export var paymentSummaryColumn = "_ik-r";
export var phoneShipmentPickerButton = "_ik-e";
export var phoneShipmentPickerButtonContent = "_ik-f";
export var phoneShipmentPickerButtonWrapper = "_ik-d";
export var phoneShipmentPickerTrigger = "_ik-c";
export var shipmentContainer = "_ik-k";
export var shipmentDetailsMainPane = "_ik-h";
export var shipmentNavigationCard = "_ik-a";
export var shipmentNavigationEdgeTrigger = "_ik-6";
export var shipmentNavigationRail = "_ik-3";
export var shipmentNavigationRailEnter = "_ik-5";
export var shipmentNavigationRailHeader = "_ik-9";
export var shipmentNavigationRailOverlay = "_ik-4";
export var shipmentNavigationScrim = "_ik-7";
export var shipmentSummaryFact = "_ik-n";
export var shipmentSummaryGrid = "_ik-m";
export var shipmentSummaryMetadataRow = "_ik-o";
export var shipmentSummaryTags = "_ik-p";
export var shipmentWorkspace = "_ik-0";
export var shipmentWorkspaceBodyTablet = "_ik-8";
export var shipmentWorkspaceContent = "_ik-b";
export var shipmentWorkspaceHeader = "_ik-1";